export default import.meta.ROLLDOWN_FILE_URL_HFnSo_t2ji54Ii8fKeJyow